export function paymentBase(row) {
    return row.source === 'customer_payment'
        ? `/customer-payments/${row.source_id}`
        : `/collections/${row.source_id || row.id}`;
}

export function matchesCollection(row, search, method) {
    const query = search.toLocaleLowerCase('tr-TR').trim();
    return (!query || `${row.customer_name || ''} ${row.job_number || ''}`.toLocaleLowerCase('tr-TR').includes(query))
        && (method === 'all' || row.payment_method === method);
}
